/**
 * Client-side environment detection. Dev is anything served from
 * localhost, 127.0.0.1, or a `dev.*` hostname — matches how nginx
 * routes dev.alisterai.com to port 3000 and alisterai.com to 3001.
 *
 * Used to gate in-progress UI (nav tabs, hero sections, debug
 * affordances) so features land on dev first and only appear on
 * prod when we remove the `devOnly` / `isDev &&` guard.
 *
 * Server-side rendering returns false — the initial HTML won't
 * show dev-only content to a prod viewer, and hydration will flip
 * it on for dev viewers once `window` is defined.
 */
export function isDevEnvironment(): boolean {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1" || host.startsWith("dev.");
}
